import { defineMessages } from 'react-intl-next';

const messages: {
	poweredBy: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	viewInConfluence: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	viewInConfluence: {
		id: 'embedded.confluence.footer.hover.text',
		description: 'Hover text on Confluence Footer Content',
		defaultMessage: 'View in Confluence',
	},
	poweredBy: {
		id: 'embedded.confluence.footer.prefix',
		description: 'Prefix label on Confluence Logo',
		defaultMessage: 'Powered by',
	},
});

export default messages;
